import { useCallback } from "react"
import { showDialog } from "@/component/Dialog";
import summarySrcStore from "@/store/summarySrc.store";
import summaryCommonStore from "@/store/summaryCommon.store";
import timingStore, { disabledRecordStatus } from "@/store/timing.store";
import { message } from "antd";
import { checkCanExit, reset } from "@/bussiness/AudioImportHandler";

/// 允许退出的条件：
/// 不在录制中+不在编辑中+没有上传中
const useChecBeforeExit = <T extends (...args: any) => unknown>(fn: T) => {
  const recordEditing = summarySrcStore((state) => state.recordEditing);
  const summaryEditing = summaryCommonStore((state) => state.summaryEditing);

  const wrapFn = useCallback(
    async (...args: Parameters<T>) => {
      if (disabledRecordStatus.includes(timingStore.getState().recordStatus)) {
        message.warning("会议记录录制中，请先结束录制再退出登录");
        return;
      }
      try {
        if (recordEditing || summaryEditing) {
          await showDialog({
            title: "当前还有未保存内容",
            content: "离开页面后将丢失编辑内容，确认离开吗？",
            confirmText: "确认",
            cancelText: "取消",
          });
        }
        const canExit = checkCanExit();
        if (canExit) {
          reset();
        } else {
          await showDialog({
            title: "确认退出",
            content: "当前还有上传中的文件，退出后将会丢失",
            confirmText: "确认",
            cancelText: "取消",
          });
          reset();
        }
        return fn(...args);
      } catch (error) {
        return;
      }
    },
    [fn]
  );
  return wrapFn;
}

export default useChecBeforeExit;